import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classNames';
import { toggleExpandAll } from '~/redux/actions/workspaceActions';
import Icon from '~/components/common/icon';

/**
 * Expand and collapse all nodes in our workspace
 *
 * @callback toggleExpandAll
 * @param {Object} props
 * @param {Object} props.workspace
 * @param {toggleExpandAll} props.toggleExpandAll
 */
const ExpandCollapseAll = ( { workspace, toggleExpandAll } ) => (
	<div
		className={ classNames( {
			'ld-expand-collapse-all': true,
			'-collapsed': ! workspace.present.expandAll,
		} ) }
	>
		<a
			href="#"
			onClick={ ( e ) => {
				e.preventDefault();
				toggleExpandAll();
			} }
		>
			{ ! workspace.present.expandAll
				? LearnDashData.i18n.expand
				: LearnDashData.i18n.collapse }
			<span>
				<Icon icon="dropdown" stroke="#0073aa" />
			</span>
		</a>
	</div>
);

/**
 * Valid props
 */
ExpandCollapseAll.propTypes = {
	workspace: PropTypes.shape( {
		present: PropTypes.object,
	} ),
	toggleExpandAll: PropTypes.func,
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => {
	return {
		workspace: state.workspace,
	};
};

/**
 *
 * @param {*} dispatch
 */
const mapDispatchToProps = ( dispatch ) => ( {
	toggleExpandAll: () => dispatch( toggleExpandAll() ),
} );

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( ExpandCollapseAll );
